import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleGrid from "./components/ArticleGrid";
import ComparisonSection from "./components/ComparisonSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <title>ACBuySpreadsheet - The Smart Spreadsheet Tracking System | acbuyspreadsheet.bond</title>
      <meta name="description" content="ACBuySpreadsheet is a powerful spreadsheet-based tracking system designed for modern workflows. Compare ACBuySpreadsheet vs Google Sheets, Excel, and Notion. Read the complete guide, explore product categories, and discover why ACBuySpreadsheet outperforms traditional spreadsheet tools with faster automation, cleaner data organization, and SEO-optimized structure." />
      <meta name="keywords" content="acbuyspreadsheet, acbuy spreadsheet, spreadsheet tracking system, spreadsheet comparison tool, acbuy spreadsheet guide" />
      <link rel="canonical" href={import.meta.env.VITE_SITE_URL + "/"} />

      <main>
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <ArticleGrid />
        <ComparisonSection />
        <TestimonialSection />
        <CTASection />
        <Footer />
      </main>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "ACBuySpreadsheet",
          "url": import.meta.env.VITE_SITE_URL + "/",
          "description": "ACBuySpreadsheet is a powerful spreadsheet-based tracking system for modern workflows.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": import.meta.env.VITE_SITE_URL + "/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
    </>
  );
}